import FormattedMessage from 'I18n/components/FormattedMessage';
import FormattedReactMessage from 'I18n/components/FormattedReactMessage';
import PropertyName from 'automation-ui-references/object-type-properties/PropertyName';
import DataSourcePropertyName from 'automation-ui-formula-editor/data-sources/DataSourcePropertyName';
import DataSourceName from 'automation-ui-formula-editor/data-sources/DataSourceName';
import PropertyValue from 'automation-ui-flow-core/fields/PropertyValue';
import { jsx as _jsx } from "react/jsx-runtime";
export default function SimpleModeSummary({
  parsedExpression,
  getActionLabelById,
  objectTypeId,
  variableContexts
}) {
  const {
    arguments: [field]
  } = parsedExpression;
  const variableContext = variableContexts.find(variable => variable.get('name') === field.name);
  const {
    identifier,
    propertyName,
    propertyToken
  } = variableContext ? variableContext.get('value') : new PropertyValue({});
  if (propertyToken) {
    return /*#__PURE__*/_jsx(FormattedReactMessage, {
      message: "automation-ui-action-features.action-features.formula.summary.simple.dataToken",
      options: {
        dataProperty: /*#__PURE__*/_jsx("strong", {
          children: /*#__PURE__*/_jsx(DataSourcePropertyName, {
            token: propertyToken
          })
        }),
        dataSource: /*#__PURE__*/_jsx("strong", {
          children: /*#__PURE__*/_jsx(DataSourceName, {
            token: propertyToken
          })
        })
      }
    });
  } else if (propertyName) {
    return /*#__PURE__*/_jsx(FormattedReactMessage, {
      message: "automation-ui-action-features.action-features.formula.summary.simple.property",
      options: {
        propertyName: /*#__PURE__*/_jsx(PropertyName, {
          propertyName: propertyName,
          objectTypeId: objectTypeId
        })
      }
    });
  } else if (identifier) {
    return /*#__PURE__*/_jsx(FormattedReactMessage, {
      message: "automation-ui-action-features.action-features.formula.summary.simple.actionOutcome",
      options: {
        actionName: /*#__PURE__*/_jsx("strong", {
          children: getActionLabelById({
            actionId: identifier.actionId
          })
        })
      }
    });
  } else {
    return /*#__PURE__*/_jsx(FormattedMessage, {
      message: "automation-ui-action-features.action-features.formula.data-source-description.no-data-source"
    });
  }
}